(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7891],{

/***/ 98456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CircularProgress_CircularProgress; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(63961);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/capitalize.js
var capitalize = __webpack_require__(98216);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js + 3 modules
var useThemeProps = __webpack_require__(32225);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/circularProgressClasses.js


function getCircularProgressUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.ZP)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0,generateUtilityClasses/* default */.Z)('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);
/* harmony default export */ var CircularProgress_circularProgressClasses = ((/* unused pure expression or super */ null && (circularProgressClasses)));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
'use client';



const _excluded = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];
let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4;











const SIZE = 44;
const circularRotateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${(0,capitalize/* default */.Z)(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${(0,capitalize/* default */.Z)(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return (0,composeClasses/* default */.Z)(slots, getCircularProgressUtilityClass, classes);
};
const CircularProgressRoot = (0,styled/* default */.ZP)('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${(0,capitalize/* default */.Z)(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: (theme.vars || theme).palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0,styled/* default */.ZP)('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0,styled/* default */.ZP)('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${(0,capitalize/* default */.Z)(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => (0,esm_extends/* default */.Z)({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));

/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */
const CircularProgress = /*#__PURE__*/react.forwardRef(function CircularProgress(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiCircularProgress'
  });
  const {
      className,
      color = 'primary',
      disableShrink = false,
      size = 40,
      style,
      thickness = 3.6,
      value = 0,
      variant = 'indeterminate'
    } = props,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};
  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressRoot, (0,esm_extends/* default */.Z)({
    className: (0,clsx/* default */.Z)(classes.root, className),
    style: (0,esm_extends/* default */.Z)({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgress);

/***/ }),

/***/ 98216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14142);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 94240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Mobadrat; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(30266);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(809);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(98456);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Footer/index.js + 1 modules
var Footer = __webpack_require__(34191);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/mobadra/Cards.js
/* eslint-disable jsx-a11y/alt-text */

/* eslint-disable import/no-unresolved */



 // import { Navigation, Pagination, Thumbs, FreeMode, Autoplay } from 'swiper'
// import { Swiper, SwiperSlide } from 'swiper/react'
// import 'swiper/css'
// import 'swiper/css/navigation'
// import 'swiper/css/pagination'
// import 'swiper/css/thumbs'




var Cards = function Cards(_ref) {
  var _item$body;

  var initiativeTrans = _ref.initiativeTrans,
      item = _ref.item;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var loader = function loader(_ref2) {
    var src = _ref2.src;
    return src;
  };

  var count = item.field_icons.split(', ');

  var _useState = (0,react.useState)(window.innerWidth),
      screenWidth = _useState[0],
      setScreenWidth = _useState[1];

  var handleWindowSizeChange = function handleWindowSizeChange() {
    setScreenWidth(window.innerWidth);
  };

  (0,react.useEffect)(function () {
    window.addEventListener('resize', handleWindowSizeChange);
    return function () {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(next_link["default"], {
    href: "".concat(locale, "/issi/").concat(item === null || item === void 0 ? void 0 : item.nid),
    passHref: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:p-6 p-3 sm:w-6/12 lg:w-1/3 cursor-pointer",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "h-full border border-grayscale-300 overflow-hidden relative px-8 py-6 flex flex-col",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat(count > 1 ? 'mb-0' : 'mb-4'),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(count > 1 ? 'h-[25px]' : 'h-[50px]', " justify-start items-center flex relative"),
            children: item.field_icons && Object.keys(item.field_icons.split(', ')).map(function (index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(next_image["default"], {
                src: "".concat(item.field_icons.split(', ')[index]),
                loader: loader,
                unoptimized: true,
                width: screenWidth >= 900 ? 80 : 80,
                height: 80,
                alt: item === null || item === void 0 ? void 0 : item.title,
                className: "mb-0 w-auto h-auto ".concat(count.length > 1 || item.field_icons.split(', ')[index] == "".concat("https://mim.gov.sa/mim/backend/", "/index.php/sites/default/files/2023-07/Logo_Icon_1.png") ? 'h-[70%]' : 'h-[80%]')
              }, index);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "bg-grayscale-100 py-2 px-3 body-xs diodrum leading-normal mb-3 inline-block text-blackscale-500 absolute rtl:left-0 ltr:right-0 top-6",
          children: locale === 'en' ? 'Industrial Motivation' : 'التحفيز الصناعي'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: "lyon mb-4 text-blackscale-500 leading-normal",
          children: item === null || item === void 0 ? void 0 : item.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "body-xs diodrum text-black leading-normal",
          children: (item === null || item === void 0 ? void 0 : (_item$body = item.body) === null || _item$body === void 0 ? void 0 : _item$body.length) <= 20 ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: item === null || item === void 0 ? void 0 : item.body
            }
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: locale === 'en' ? (item === null || item === void 0 ? void 0 : item.body.substring(0, 100)) + '...' : (item === null || item === void 0 ? void 0 : item.body.substring(0, 200)) + '...'
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(next_link["default"], {
            href: "".concat(locale, "/issi/").concat(item === null || item === void 0 ? void 0 : item.nid),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
              className: "btn btn-black text-sm py-3 mt-4 inline-block",
              children: [initiativeTrans === null || initiativeTrans === void 0 ? void 0 : initiativeTrans.initiative_details, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "rtl:align-middle rtl:mr-3 ltr:ml-3 ltr:rotate-180 inline-block leading-none before:bg-arrow-left-white before:inline-block before:w-[25px] before:h-[16px]"
              })]
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ var mobadra_Cards = (Cards);
;// CONCATENATED MODULE: ./pages/issi/index.js













function Mobadrat() {
  var _initiativeContent$ro, _initiativeTrans$brea, _initiativeTrans$brea2, _initiativeContent$ro2, _initiativeContent$ro3;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale;

  var _useState = (0,react.useState)({}),
      initiativeTrans = _useState[0],
      setInitiativeTrans = _useState[1];

  var _useState2 = (0,react.useState)([]),
      initiativeContent = _useState2[0],
      setInitiativeContent = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var fetchInitiativeTrans = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return axios_default()({
                method: 'GET',
                url: "/local_industry/translation"
              });

            case 3:
              response = _context.sent;
              setInitiativeTrans(response === null || response === void 0 ? void 0 : response.data);
              setLoading(false);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchInitiativeTrans() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetechInitiativeContent = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var response;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return axios_default()({
                method: 'GET',
                url: "/local_industry"
              });

            case 2:
              response = _context2.sent;
              setInitiativeContent(response === null || response === void 0 ? void 0 : response.data);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetechInitiativeContent() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    fetchInitiativeTrans();
    fetechInitiativeContent();
  }, [locale]);
  var schema = initiativeContent === null || initiativeContent === void 0 ? void 0 : (_initiativeContent$ro = initiativeContent.rows) === null || _initiativeContent$ro === void 0 ? void 0 : _initiativeContent$ro.map(function (item) {
    return {
      '@context': 'https://schema.org',
      '@type': 'NewsArticle',
      headline: item === null || item === void 0 ? void 0 : item.title,
      image: Object.keys(item.field_icons.split(', ')).map(function (index) {
        return item === null || item === void 0 ? void 0 : item.field_icons;
      }),
      author: {
        '@type': 'Person',
        name: (item === null || item === void 0 ? void 0 : item.title.substring(0, 100)) + '...',
        url: "".concat("https://mim.gov.sa/mim", "/issi/").concat(item === null || item === void 0 ? void 0 : item.nid)
      }
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(head["default"], {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: locale === 'en' ? "Ministry of Industry and Mineral Resources - ".concat(initiativeTrans === null || initiativeTrans === void 0 ? void 0 : initiativeTrans.page_title) : "\u0648\u0632\u0627\u0631\u0629 \u0627\u0644\u0635\u0646\u0627\u0639\u0629 \u0648\u0627\u0644\u062B\u0631\u0648\u0629 \u0627\u0644\u0645\u0639\u062F\u0646\u064A\u0629 - ".concat(initiativeTrans === null || initiativeTrans === void 0 ? void 0 : initiativeTrans.page_title)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(schema)
        }
      }, "news-jsonld")]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "bg-cover ltr:-scale-x-100 min-h-[200px] md:h-[297px] flex items-center relative py-4 bg-[#262626] bg-[url('/images/newimg/iii.png')] before:absolute before:bg-[url('/images/banner-overly.png')] before:bg-no-repeat before:bg-cover before:left-0 before:top-0 before:h-full before:w-full before:mix-blend-multiply",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container px-4 mx-auto relative ltr:-scale-x-100",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
          className: " text-white lyon leading-normal",
          children: initiativeTrans === null || initiativeTrans === void 0 ? void 0 : initiativeTrans.page_title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
          className: "text-white lyon mt-4",
          children: initiativeTrans === null || initiativeTrans === void 0 ? void 0 : initiativeTrans.page_title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
          "aria-label": "Breadcrumb",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", {
            className: "inline-flex flex-wrap items-center text-light-gray mt-4 text-body-md font-lyon-semibold",
            children: (initiativeTrans === null || initiativeTrans === void 0 ? void 0 : (_initiativeTrans$brea = initiativeTrans.breadcrumb) === null || _initiativeTrans$brea === void 0 ? void 0 : _initiativeTrans$brea.length) > 0 && (initiativeTrans === null || initiativeTrans === void 0 ? void 0 : (_initiativeTrans$brea2 = initiativeTrans.breadcrumb) === null || _initiativeTrans$brea2 === void 0 ? void 0 : _initiativeTrans$brea2.map(function (item, ind) {
              var _initiativeTrans$brea3;

              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "".concat(ind > 0 ? "before:content-['/'] before:mx-2" : null),
                children: (initiativeTrans === null || initiativeTrans === void 0 ? void 0 : (_initiativeTrans$brea3 = initiativeTrans.breadcrumb) === null || _initiativeTrans$brea3 === void 0 ? void 0 : _initiativeTrans$brea3.length) === ind + 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "text-light-gray capitalize",
                  children: item === null || item === void 0 ? void 0 : item.label
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)(next_link["default"], {
                  href: item === null || item === void 0 ? void 0 : item.url,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "text-light-gray hover:text-greenscale-500 capitalize",
                    "aria-label": item === null || item === void 0 ? void 0 : item.title,
                    children: item === null || item === void 0 ? void 0 : item.label
                  })
                })
              }, ind);
            }))
          })
        })]
      })
    }), loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center items-center loader-items py-10 min-h-[300px]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
        style: {
          color: '#1AD9C7'
        }
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: "initMenu",
      className: "bg-[#f9f9fb] w-full sticky top-0 left-0 z-[8] py-[48px]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container px-4 mx-auto flex flex-wrap",
        children: (initiativeContent === null || initiativeContent === void 0 ? void 0 : (_initiativeContent$ro2 = initiativeContent.rows) === null || _initiativeContent$ro2 === void 0 ? void 0 : _initiativeContent$ro2.length) > 0 && (initiativeContent === null || initiativeContent === void 0 ? void 0 : (_initiativeContent$ro3 = initiativeContent.rows) === null || _initiativeContent$ro3 === void 0 ? void 0 : _initiativeContent$ro3.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(mobadra_Cards, {
            initiativeTrans: initiativeTrans,
            item: item
          }, item.nid);
        }))
      })
    })]
  });
}

/***/ }),

/***/ 11318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/issi",
      function () {
        return __webpack_require__(94240);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63961:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e)){var o=e.length;for(t=0;t<o;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f)}else for(f in e)e[f]&&(n&&(n+=" "),n+=f);return n}function clsx(){for(var e,t,f=0,n="",o=arguments.length;f<o;f++)(e=arguments[f])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["Z"] = (clsx);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,1689,950,7814,4191,9774,2888,179], function() { return __webpack_exec__(11318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);